<template>
    <div class="yassytower-plans">
        <div class="container">
            <div class="land-section-title">
                <h2>Планировки</h2>
            </div>
            <div class="plans-items">
                <div class="item" v-for="(item, index) in salesCard.plans" @click.prevent="settingDataFlatsCardModal(item)" :key="index">
                    <div class="item-title">
                        <h3>{{item.name}}</h3>
                        <h4><span class="title">Общая площадь:</span>{{item.plan_size}} <span>м²</span></h4>
                    </div>
                    <div class="item-img">
                        <img :src="item.floor_img" alt="">
                    </div>
                </div>
            </div>
        </div>
        <!-- модалка планировки -->
        <modal name="yassytower_flat-card-modal" @opened="FlatCardModalOpened" @closed="FlatCardModalClosed" :transition="transitionName" :width="modalWidth" :height="modalHeight" :scrollable="modalScroll" id="yassytower_flat-card-modal" v-if="modalData != null">
            <flatModal :config="[{active: formActive, mobile: mobile}]"></flatModal>
        </modal>
        <!-- end -->
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    // import PROMOpage from '@/components/sales/sales-promo-page.vue'
    import flatModal from '@/components/sales-land-partials/partials/yassytower-flats-modal.vue'
    export default {
        name: 'sales-aqualina-flats',
        components: {
            flatModal,
        },
        data () {
            return {
                activeFlats: 'villa',
                modalWidth: 1000,
				modalHeight: 400,
				modalScroll: false,
				formActive: false,
				mobile: false,
				transitionName: '',
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            modalData: 'loadSalesLandModalDataArr',
        }),
        methods: {
            settingDataFlatsCardModal(arr) {
				
				this.$store.commit('modalData', arr);
                console.log(this.modalData)
				this.$modal.show('yassytower_flat-card-modal');
				// this.$store.commit('Open_Form_Modal', false);
				// document.getElementById('secret-btns').classList.remove('fadeIn');
			},
            FlatCardModalClosed() {
				// this.formActive = false;
				window.body.removeClass('overflowTrue');
				// document.getElementById('secret-btns').classList.remove('hideAll');
                document.getElementById('header').classList.remove('notvisibleSalesLand');
                document.getElementById('landNav').classList.remove('notvisibleSalesLand');
                // document.getElementById('banerTopHorizont').classList.remove('notvisibleSalesLand');
                document.getElementById('footer').classList.remove('notvisibleSalesLand');
			},
			FlatCardModalOpened() {
				window.Sharer.init();
				window.body.addClass('overflowTrue');
				// document.getElementById('secret-btns').classList.add('hideAll');
				document.getElementById('header').classList.add('notvisibleSalesLand');
                document.getElementById('landNav').classList.add('notvisibleSalesLand');
                // document.getElementById('banerTopHorizont').classList.add('notvisibleSalesLand');
                document.getElementById('footer').classList.add('notvisibleSalesLand');
			},
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/partials/yassytower-flats.scss';
    @import '@/styles/respond/sales/sales-land-partials/partials/yassytower-flats-respond.scss';
    // @import '@/styles/respond/sales/sales-land-partials/land-about-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>